(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inThemeEditor = !!window.Shopify?.designMode;
  if (reducedMotion || inThemeEditor) return;

  if (!window.Lenis) {
    console.warn('[Lenis] não carregou.');
    return;
  }

  const lenis = new Lenis({
    // "peso" premium sem virar gelatina
    lerp: 0.08,

    // bom para trackpad/wheel
    wheelMultiplier: 0.9,

    smoothWheel: true,
    smoothTouch: false,

    // versões novas suportam isto; se não existir, ignora
    autoRaf: true
  });

  // fallback caso a tua build não suporte autoRaf
  if (!('autoRaf' in (lenis.options || {}))) {
    const raf = (t) => { lenis.raf(t); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
  }

  // Âncoras suaves
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;

    const id = a.getAttribute('href');
    if (!id || id === '#') return;

    const target = document.querySelector(id);
    if (!target) return;

    e.preventDefault();
    lenis.scrollTo(target, { offset: -80 });
    history.pushState(null, '', id);
  });

  // Theme Editor mexe no DOM (secções)
  document.addEventListener('shopify:section:load', () => lenis.resize?.());
  document.addEventListener('shopify:section:reorder', () => lenis.resize?.());
  document.addEventListener('shopify:section:select', () => lenis.resize?.());

  // Exemplo: bloquear scroll dentro de drawers/modais
  // mete data-lenis-prevent no container scrollável do drawer/modal
})();
